module.exports = __webpack_public_path__ + "img/spongebob_squarepants_characters_scan.a5dff1cc.jpg";